<template>
  <div
    class="pageFooterBottom onLineIndex"
    :style="{
      background: `linear-gradient(180deg, ${bgColor} 8%, var(--bgColor) 260px`,
    }"
  >
    <Header
      :title="$route.query.name"
      bgColor="transparent"
      :isShadow="false"
      :isFixed="false"
    />
    <!-- <div class="pageFontWeight tabTitle" slot="title">
      {{ $route.query.name }}
    </div> -->
    <div>
      <Inspect
      v-if="
          link === 'inspect' ||
          link === 'safeStop' ||
          link === 'drivingProtect' ||
          link === 'moveCarService' ||
          link === 'violationSearch'
        "
        :couponsName="couponsName"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :ident="link"
        :mouldId="mouldId"
      />
    </div>
    <!-- 卡券余额支付列表 -->
    <van-popup
      v-model="couponsBalanceShow"
      round
      position="bottom"
      class="couponsBalanceList"
    >
      <div class="van-coupon-list">
        <div class="van-tabs__content">
          <div role="tabpanel" class="van-tab__pane" style="">
            <div
              class="van-coupon-list__list van-coupon-list__list--with-bottom"
            >
              <van-checkbox-group
                v-model="couponsBalanceChecked"
                ref="checkboxGroup"
                @change="changeCheckboxes"
              >
                <div
                  class="van-coupon"
                  :style="item.is_can_use == 0 ? 'filter: grayscale(1);' : ''"
                  @click="toggle(index, item.couponsStatus)"
                  v-for="(item, index) in couponsBalanceList"
                  :key="index"
                >
                  <div class="van-coupon__content">
                    <div class="van-coupon__head">
                      <!-- <van-image :src="lgImg" width="32" height="32" /> -->
                      <van-icon class="iconfont iconqiaquanguanli" size="32" />
                    </div>
                    <div class="van-coupon__body">
                      <p class="van-coupon__name">
                        {{ item.couponsProductName }}
                      </p>
                      <p class="van-coupon__valid">
                        <!-- <span>ID：{{ item.couponsId }}</span> -->
                        <span>到期时间：{{ item.couponsEndDate }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="van-coupon__description">
                    <div class="left">
                      <p class="money">
                        余额
                        <span style="font-weight: 700; font-size: 16px">￥</span
                        ><span class="number">{{
                          $formatMoney(Number(item.couponsBalance), 2).split(
                            "."
                          )[0]
                        }}</span
                        ><span style="font-weight: 700; font-size: 18px"
                          >.{{
                            $formatMoney(Number(item.couponsBalance), 2).split(
                              "."
                            )[1]
                          }}</span
                        >
                      </p>
                      <!-- <p class="remark">备注：说明XXXXXXXX</p> -->
                    </div>
                    <div class="right">
                      <van-checkbox
                        checked-color="#f90"
                        ref="checkboxes"
                        :name="item"
                        :disabled="item.couponsStatus == 0"
                        @click="checkboxclick"
                      ></van-checkbox>
                    </div>
                  </div>
                </div>
              </van-checkbox-group>
            </div>
          </div>
        </div>
        <div class="van-coupon-list__bottom" style="position: fixed">
          <button
            class="van-button van-button--danger van-button--normal van-button--block van-button--round van-coupon-list__close"
            @click="couponsBalanceShow = false"
          >
            <div class="van-button__content">
              <span class="van-button__text">确定</span>
            </div>
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Inspect from "./Inspect";
import { getValidCoupons } from "api/onLine";
import { Dialog } from "vant";

export default {
  components: {
    Inspect,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      bgColor: "var(--depYelColor)",
      lineWidth: "80px",
      active: 0,
      bgImg: require("assets/u2.png"),
      list: [],
      show: false,
      sms: "",
      phone: "",
      data: "",
      isDisabled: false,
      balance: 0,
      balanceChecked: false,
      payData: "",
      showDialogs: false,
      showDialogs2: false,
      radio: "",
      couponsName: "",
      isMember: false,
      couponType: 1,
      chosenCoupon: -1,
      coupons: [],
      disabledCoupons: [],
      chosenCoupon2: -1,
      coupons2: [],
      disabledCoupons2: [],
      couponsBalanceList: [],
      couponsBalanceShow: false,
      couponsBalanceChecked: [],
      couponsDeduct: 0,
      cards: "",
      sell_price: 0,
      number: -1,
      current_couponsBalance: 0,
      oldTitle: "",
      link: "",
      categoryId: 0,
      mouldId: 0,
      upstreamId: 0,
      buyerUserId: 0,
    };
  },
  created() {},
  mounted() {
    let ident = this.$route.query.categoryIdent;
    this.setBackground(ident);
    this.link = ident;
    this.categoryId = this.$route.query.categoryId;
    this.upstreamId = this.$route.query.upstreamId;
    this.buyerUserId = this.$route.query.buyerUserId;
    this.mouldId = this.$route.query.mouldId;
    // this.getValidCoupons();
  },
  methods: {
    checkboxclick() {
      if (this.sell_price <= 0) {
        this.couponsBalanceChecked = [];
      }
    },
    changeCheckboxes(names) {
      let arryLists = "";
      let money = 0;
      for (let i = 0; i < names.length; i++) {
        const element = names[i];
        if (i == 0) {
          arryLists += element.couponsId;
        } else {
          arryLists += "," + element.couponsId;
        }
        money += Number(element.couponsBalance);
      }

      let remainder = this.sell_price - money;
      remainder = remainder > 0 ? money : this.sell_price;
      this.couponsDeduct = Number(remainder >= 0 ? remainder : 0);
      this.cards = arryLists;
      if (arryLists != "") {
        this.number = arryLists.split(",").length;
      } else {
        this.number = 0;
      }
    },
    toggle(index, is_can_use) {
      if (is_can_use == 0 || this.balanceChecked) {
        return;
      }
      if (this.sell_price <= 0) {
        this.$error(this.chosenCoupon <= 0 ? "请先选择面值" : "卡券已抵扣");
        this.couponsBalanceShow = false;
        return;
      }
      let now = this.$refs.checkboxes[index];
      let price = this.sell_price;
      let arry = this.couponsBalanceChecked;
      let sum = 0;
      for (let index = 0; index < arry.length; index++) {
        const element = arry[index];
        sum += Number(element.couponsBalance);
      }
      console.log(sum, price, now.checked);
      if (sum >= price && !now.checked) {
        this.$error("当前已满足支付金额");
        return false;
      } else {
        now.toggle();
      }
    },
    getUserInfo() {
      this.getValidCoupons();
    },
    getValidCoupons() {
      getValidCoupons(
        this.categoryId,
        this.upstreamId,
        this.buyerUserId,
        this.mouldId
      ).then((res) => {
        if (res.status == 200) {
          this.couponsBalanceList = res.data;
        } else {
          this.$error(res.message);
        }
      });
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        done(false);
      } else {
        done();
      }
    },
    cancel() {
      this.sms = "";
    },
    showDialog(i, data) {
      this.phone = i;
      this.payData = data;
      this.show = true;
    },
    Onclick(name, title) {
      if (this.oldTitle == title) {
        return;
      }
      this.oldTitle = title;
      this.couponsBalanceChecked = [];
      this.sell_price = 0;
      this.setBackground(title);
      this.number = -1;
    },
    //重置选中
    setChecked(val) {
    },
    // 设置背景色
    setBackground(val) {
      this.bgColor = "#e98f36";
      // switch (val) {
      //   case "inspect":
      //     this.bgColor = "#e98f36";
      //     break;
      // }
    },
  },
};
</script>

<style scoped lang="less">
.onLineIndex {
  .tabTitle {
    color: #fff;
    text-align: left;
    padding-top: 10px;
    font-size: 25px;
    padding-left: 20px;
  }
}
.couponsBalanceList {
  height: 65%;
  background-color: rgb(247, 248, 250);
  .van-coupon-list__list {
    overflow-y: initial;
  }
  .van-coupon {
    border: 2px solid #ff9900;
    .van-coupon__content {
      background-image: linear-gradient(-90deg, #fceabb, #f8b500);
      color: #fff;
      min-height: initial;
      padding: 10px 0;
      .van-coupon__head {
        min-width: initial;
        padding: 0 15px;
      }
    }
    .van-coupon__body {
      .van-coupon__valid {
        display: flex;
        justify-content: space-between;
        margin-right: 15px;
      }
      .van-coupon__name {
        margin-bottom: 5px;
      }
    }
    .van-coupon__description {
      padding: 15px;
      border-top: initial;
      display: flex;
      justify-content: space-between;
      .left {
        width: 90%;
        text-align: center;
        line-height: 1.5;
        .money {
          color: red;
          font-size: 14px;
          .number {
            font-size: 30px;
            font-weight: 700;
          }
        }
        .remark {
          font-size: 14px;
          color: #ccc;
        }
      }
      .right {
        display: flex;
        align-items: center;
        /deep/
          .van-checkbox__icon--disabled.van-checkbox__icon--checked
          .van-icon {
          color: #fff;
          background: #f90;
          border-color: #f90;
        }
        /deep/ .van-checkbox__icon--disabled .van-icon {
          background-color: #ddd;
          border-color: #ddd;
        }
      }
    }
  }
}
</style>
